/* eslint-disable no-param-reassign */
const state = {
  isOverflowHidden: false,
  updateStatus: false,
  responsiveMenuStatus: false,
  navMenuCloseIcon: false,
  routeChanged: false,
};

// getters
const getters = {
  getOverflowState: (state) => state.isOverflowHidden,
  getResponsiveMenuStatus: (state) => state.responsiveMenuStatus,
  getNavMenuCloseIcon: (state) => state.navMenuCloseIcon,
  getRouteChanged: (state) => state.routeChanged,
};

// mutations
const mutations = {
  setRouteChanged (state, value) {
    state.routeChanged = value;
  },
  toggleOverflowState (state) {
    state.isOverflowHidden = !state.isOverflowHidden;
  },
  addOverflowState (state) {
    state.isOverflowHidden = true;
  },
  removeOverflowState (state) {
    state.isOverflowHidden = false;
  },
  setNavMenuCloseIcon (state, value) {
    state.navMenuCloseIcon = value === false || value === true ? value : !state.navMenuCloseIcon;
  },
  setResponsiveMenuStatus (state, value) {
    state.responsiveMenuStatus = value === false ? value : !state.responsiveMenuStatus;
  },
};
// actions
const actions = {
  callToggleOverflowState ({
    commit,
  }) {
    commit('toggleOverflowState');
  },
  callAddOverflowState ({
    commit,
  }) {
    commit('addOverflowState');
  },
  callRemoveOverflowState ({
    commit,
  }) {
    commit('removeOverflowState');
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
